import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { CircularProgress, Grid, IconButton, Typography } from '@mui/material';
import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import Card from '../components/CardDocuments';
import FilterComponent from '../components/FilterComponent';
import "../components/css/SignedDocuments.css";
import texts from '../constants/views/signedDocumentsText';
import documentosFirmadosNormal from "../img/navbar/documentosFirmadosNormal.svg";
import useAxiosKeycloak from '../hooks/useAxiosKeycloak';

const SignedDocuments = ({ keycloak }) => {
    const axiosKeycloak = useAxiosKeycloak(keycloak);
    const [documentList, setDocumentList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filteredDocumentList, setFilteredDocumentList] = useState([]);
    const [noDocuments, setNoDocuments] = useState(false);
    const [errorMessageConnection, setErrorMessageConnection] = useState("");
    const [isEmailSectionVisible, setIsEmailSectionVisible] = useState(false);

    const handleToggleSection = () => {
        setIsEmailSectionVisible(!isEmailSectionVisible);
    };
    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const response = await axiosKeycloak.get(
                `${process.env.REACT_APP_BACKEND_URL}${process.env.REACT_APP_GET_DOCS_INFO}?estadosDocumento=2&estadosFirma=2`,
                {
                    timeout: 20000,
                }
            );
            const responseData = response.data;
            responseData.sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
            setDocumentList(responseData);
            setFilteredDocumentList(responseData);

            if (responseData.length === 0) {
                setNoDocuments(true);
            }

        } catch (error) {
            if (axios.isCancel(error)) {
                setErrorMessageConnection(texts.errorMessages.rechazo, error.message);
            } else if (error.code === 'ECONNABORTED') {
                setErrorMessageConnection(texts.errorMessages.peticionTardo);
            } else {
                const errorMsg = error.response?.data?.errorMsg || texts.errorMessages.networkError;
                setErrorMessageConnection(errorMsg);
            }
        } finally {
            setLoading(false); // Finaliza la carga, independientemente del resultado
        }
    }, [axiosKeycloak]);


    const handleSearchResults = (results) => {
        setFilteredDocumentList(results);
    };
    const handleFilterResults = (filteredResults) => {
        setFilteredDocumentList(filteredResults);
    };
    useEffect(() => {
        fetchData();
    }, [fetchData]);
    const isMobile = window.innerWidth < 900;
    return (
        <>
            {loading && (
                <Grid container justifyContent="center" alignItems="center">
                    <CircularProgress aria-busy="true"
                        aria-label="Cargando..." sx={{ color: "#316094" }} />
                </Grid>
            )}

            {!loading && noDocuments && !errorMessageConnection && (
                <Typography variant="body1" sx={{ margin: "auto", fontFamily: "robotoMedium", padding: "10px" }} gutterBottom>
                    {texts.noTieneDoc}
                </Typography>
            )}

            {!loading && !noDocuments && (
                <>
                    {isEmailSectionVisible ? (
                        <div className="blue-backgroundSignedDocuments">
                            <div className="rectangleSignedDocuments" aria-label="Sección de filtros para documentos">
                                <FilterComponent documentList={documentList} onSearchResults={handleSearchResults} estadosDocumento={"?estadosDocumento=2&"} section="FIRMADO" keycloak={keycloak} onFilter={handleFilterResults} />
                            </div>
                        </div>
                    ) : null}
                    <div className="iconButtonContainerSigner">
                        <div class="color-bandSigner"></div>
                        <IconButton
                            onClick={handleToggleSection}
                            className="iconButtonSigner"
                            aria-label={isEmailSectionVisible ? "Cerrar sección de filtros" : "Abrir sección de filtros"}
                        >
                            {isEmailSectionVisible ? (
                                <ArrowBack sx={{ color: "white" }} />
                            ) : (
                                <ArrowForward sx={{ color: "white" }} />
                            )}
                        </IconButton>
                    </div>
                    {/* Contenedor para las tarjetas */}
                    <div className="scroll-containerSignedDocuments" role="region"
                        aria-label="Lista de documentos firmados" sx={{
                            justifyContent: isMobile
                                ? filteredDocumentList.length === 1
                                    ? 'flex-start !important'
                                    : 'center !important'
                                : null,
                        }}>
                        {isMobile ? (<div style={{ display: "flex", width: "90%", alignItems: "center" }}>
                            <img src={documentosFirmadosNormal} alt="" style={{ margin: '0px 10px 0px 0px' }} />
                            <Typography sx={{ width: "90%", textAlign: "left", color: "#316094", fontFamily: "robotoMedium" }}>{texts.title}</Typography>
                            <Typography
                                component="span"
                                aria-label={`Tiene actualmente ${filteredDocumentList.length} documento${filteredDocumentList.length !== 1 ? "s" : ""} firmado${filteredDocumentList.length !== 1 ? "s" : ""}.`}
                                className="visually-hidden"
                                aria-live="polite"
                            >
                                {`Tiene actualmente ${filteredDocumentList.length} documento${filteredDocumentList.length !== 1 ? "s" : ""} firmado${filteredDocumentList.length !== 1 ? "s" : ""}.`}
                            </Typography>
                        </div>) : <Typography
                            component="span"
                            aria-label={`Tiene actualmente ${filteredDocumentList.length} documento${filteredDocumentList.length !== 1 ? "s" : ""} firmado${filteredDocumentList.length !== 1 ? "s" : ""}.`}
                            className="visually-hidden"
                            aria-live="polite"
                        >
                            {`Tiene actualmente ${filteredDocumentList.length} documento${filteredDocumentList.length !== 1 ? "s" : ""} firmado${filteredDocumentList.length !== 1 ? "s" : ""}.`}
                        </Typography>}
                        <Grid container spacing={2} sx={{ backgroundColor: "#F0F0F2", width: "90%", padding: "16px", margin: "40px 0px" }}>
                            {filteredDocumentList.map((documentInfo) => (
                                <Grid item sx={{ padding: "0 !important", }} xs={12} sm={filteredDocumentList.length === 1 ? 12 : 6} key={documentInfo.id}>
                                    <div className="DivCardSignedDocuments">
                                        <Card keycloak={keycloak} documentInfo={documentInfo} section="FIRMADO" />
                                    </div>
                                </Grid>
                            ))}
                            {filteredDocumentList.length === 0 && !errorMessageConnection && (
                                <Typography variant="body1" sx={{ margin: "auto", fontFamily: "robotoMedium" }} gutterBottom role="alert"
                                    aria-live="assertive">
                                    {texts.errorMessages.noCoincidencia}
                                </Typography>
                            )}
                            {!loading && filteredDocumentList.length === 0 && errorMessageConnection && (
                                <Typography variant="body1" sx={{ margin: "auto", color: "red", fontFamily: "robotoMedium" }} gutterBottom role="alert"
                                    aria-live="assertive">
                                    {errorMessageConnection}
                                </Typography>
                            )}
                        </Grid>
                    </div>
                </>
            )}
        </>
    );
};


export default SignedDocuments;
